// Color theme switching (Original <-> Power <-> MCA Dark).
// Persists the choice in localStorage and toggles a `theme-<name>` class on
// <html>; the CSS variables under `:root.theme-power` / `:root.theme-mcadark`
// in index.css repaint the whole app. Default (no class) = the original look.

export const COLOR_THEME_KEY = 'pfs_color_theme';

const THEMES = ['original', 'power', 'mcadark'];

export function getColorTheme() {
  try {
    const stored = localStorage.getItem(COLOR_THEME_KEY);
    return THEMES.includes(stored) ? stored : 'original';
  } catch (e) {
    return 'original';
  }
}

export function applyColorTheme(theme) {
  if (typeof document === 'undefined') return;
  document.documentElement.classList.toggle('theme-power', theme === 'power');
  document.documentElement.classList.toggle('theme-mcadark', theme === 'mcadark');
}

export function setColorTheme(theme) {
  const next = THEMES.includes(theme) ? theme : 'original';
  try {
    localStorage.setItem(COLOR_THEME_KEY, next);
  } catch (e) {
    // ignore storage failures
  }
  applyColorTheme(next);
  return next;
}
